// this file is generated by update_shopify_store_data.py at 2026-02-23 20:32:51.203719
var courses = [
    {
        "course_id": "FD63D42A-28BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "An Introduction to the 10 Caritas Processes\u00ae",
        "course_type": 1,
        "author_information": "Watson Caring Science Institute",
        "description": "Caring Science, developed by Dr. Jean Watson, invites us to see caring as a way of being grounded in human connection and evidence-based practice. This course introduces the 10 Caritas Processes\u00ae as guiding commitments to compassion, presence, and whole-person care. Through reflections and stories from Dr. Gloria Littlemouse, you will see how these processes come to life in practice\u2014offering insight, resilience, and inspiration for nursing in moments of both challenge and healing.",
        "learning_objectives_html": "By the end of the course, learners will be able to:\r\n<ol>Describe the philosophy of Caring Science and the 10 Caritas Processes&reg; as foundations for compassionate, evidence-based nursing practice.</ol>\r\n    <ol>Analyze case examples and stories to determine how the Caritas Processes&reg; are demonstrated in real-world nursing encounters.</ol>\r\n        <ol>Develop a personal action plan to integrate the Caritas Processes&reg; into daily practice to enhance healing relationships and resilience.</ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "77F16213-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - An Introduction to the 10 Caritas Processes\u00ae",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Care Coordination",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F02E223C-F6D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: An Introduction to the 10 Caritas Processes\u00ae",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                "course_category_name": "Cardiac Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 2.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];